import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "helpers";

export async function getFeatureModuleSetting(tab_hint) {
  return axiosInstance
    .get("allfeaturesettings", {
      params: {
        api_key: localStorage.getItem("apikey"),
        added_by: localStorage.getItem("user_id"),
        tab_hint,
        website_id: null ,
      },
    })
    .then((response) => response.data)
    .catch((error) => error);
}

export function useGetFeatureModuleSetting(module) {
  return useQuery([module], () => getFeatureModuleSetting(module));
}
